import { GoPlus, GoDash } from "react-icons/go";
import { IoIosArrowForward } from "react-icons/io";
import { RiStore2Line } from "react-icons/ri";
import { Row, Col } from "reactstrap";
import styles from './Cart.module.scss';

const CartItem = ({ image, storeName, itemName, price, size, quantity, onAdd, onSubtract }) => (

  <div className={styles.cartItemContainer}>
    <Row noGutters className={`flex-grow-1 ${styles.cartItemRow}`}>
      <div className={styles.storeWrapper}>
        <span>
          <RiStore2Line size={18} className={styles.storeIcon} />
        </span>
        <span className={styles.storeName}>{storeName}</span>
        <span>
          <IoIosArrowForward size={18} className={styles.storeArrow} />
        </span>
      </div>

      <Col xs={7} sm={9}>
        <div className={styles.cartItemDetail}>
          <div>
            <img src={image} alt="Product Image" />
          </div>
          <div className={styles.cartItemProductSpec}>
            <div>
              <p className={styles.productName}>{itemName}</p>
              <span className={styles.productSpec}>{size}</span>
            </div>
            <div className={styles.productQuantity}>
              <button
                className={styles.quantityCheckSubtractBtn}
                onClick={onSubtract}
                disabled={quantity === 1}
              >
                <GoDash />
              </button>
              <span className={styles.quantityNumber}>{quantity}</span>
              <button
                className={styles.quantityCheckAddBtn}
                onClick={onAdd}
              >
                <GoPlus />
              </button>
            </div>
          </div>
        </div>
      </Col>

      <Col xs={5} sm={3}>
        <p className={styles.productPrice}>
          ${(price * quantity).toFixed(2)}
        </p>
      </Col>
    </Row>
  </div>
)

export default CartItem;